"use strict";

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      height: 20px;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & > img {\n    height: 16px;\n    object-fit: contain;\n    vertical-align: middle;\n    background-color: transparent !important;\n\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var imgBlack = "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/logo_black.png";
var imgWhite = "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/logo_white.png";
var Wrapper = styled_components_1["default"].a(_templateObject(), bitcoincom_pkg_theme_1.media.md(_templateObject2()));
/**
 * Main Bitcoin.com Logo
 * @param {Object} props component props
 * @param {boolean} props.contrast @default false set to white
 */

var Logo = function Logo(_a) {
  var _a$contrast = _a.contrast,
      contrast = _a$contrast === void 0 ? false : _a$contrast,
      rest = __rest(_a, ["contrast"]);

  return react_1["default"].createElement(Wrapper, Object.assign({
    href: "https://www.bitcoin.com/"
  }, rest), react_1["default"].createElement("img", {
    src: contrast ? imgWhite : imgBlack,
    alt: "Bitcoin.com"
  }));
};

exports["default"] = Logo;